var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("暂无加入的公司或分配的页面！")])
}
var staticRenderFns = []

export { render, staticRenderFns }